/**
 * Created by MRQ on 2016/1/6.
 */
"use strict";
angular.module("productManageMentAppServiceModule", [
        'productManageMentAppServiceCtrlModule',
        'productManageMentAppDeleteViewsModule',
        'productManageMentAppModifyViewsModule',
        "appBindTemplateModule",
        "appInputPasswordModule",
        "appManageConfigSingleChooseChnlModule",
        "appManageConfigBatChooseChnlModule",
        "productManageMentAppExternalSysModule",
        "productManageMentAppNewAndModifyExternalSysModule",
        "productManageMentAppNewTagModule",
        "productManageMentAppDistributeAddModule",
        "productAppDistributeAddModule",
        "createThirdPartyConfigModule"
    ])
    .factory("productMangageMentAppService", ["$q", "$modal", "localStorageService", "trsHttpService", "globleParamsSet", "modalDialog", function($q, $modal, localStorageService, trsHttpService, globleParamsSet, modalDialog) {
        return {
            //删除弹窗
            deleteViews: function(successFn) {
                var modalInstance = $modal.open({
                    templateUrl: "./manageConfig/productManageMent/app/service/delete/app_delete_tpl.html",
                    windowClass: 'productManageMent-app-delete-view',
                    backdrop: false,
                    controller: "productManageMentAppDeleteViewsCtrl",
                    resolve: {
                        successFn: function() {
                            return successFn;
                        }
                    }
                });
                return modalInstance.result.then(function(result) {
                    //success(result);
                });
            },
            //修改弹窗
            modifyViews: function(title, successFn) {
                var modalInstance = $modal.open({
                    templateUrl: "./manageConfig/productManageMent/app/service/modify/app_modify_tpl.html",
                    windowClass: 'productManageMent-app-modify-view',
                    backdrop: false,
                    controller: "productManageMentAppChannelModifyViewsCtrl",
                    resolve: {
                        title: function() {
                            return title;
                        },
                        successFn: function() {
                            return successFn;
                        }
                    }
                });
                return modalInstance.result.then(function(result) {
                    // success(result);
                });
            },
            //回收站删除弹窗
            recycleDeleteViews: function(params, success) {
                var modalInstance = $modal.open({
                    templateUrl: "./manageConfig/productManageMent/app/service/template/recycle_bin_delete_view.html",
                    windowClass: 'productManageMent-app-recycle-delete',
                    backdrop: false,
                    controller: "productManageMentAppRecycleDeleteCtrl",
                    resolve: {
                        params: function() {
                            return params;
                        }
                    }
                });
                return modalInstance.result.then(function(result) {
                    success();
                });
            },
            //回收站还原弹窗
            recycleReductionViews: function(params, success) {
                var modalInstance = $modal.open({
                    templateUrl: "./manageConfig/productManageMent/app/service/template/recycle_bin_reduction_view.html",
                    windowClass: 'productManageMent-app-recycle-reduction',
                    backdrop: false,
                    controller: "productManageMentAppRecycleReductionCtrl",
                    resolve: {
                        params: function() {
                            return params;
                        }
                    }
                });
                return modalInstance.result.then(function(result) {
                    success();
                });
            },
            bindTemplate: function(params, success) {
                var modalInstance = $modal.open({
                    templateUrl: "./manageConfig/productManageMent/app/service/bindTemplate/channl_tpl.html",
                    windowClass: 'pmm-app-column-modify-channl-other',
                    backdrop: false,
                    resolve: {
                        params: function() {
                            return params;
                        }
                    },
                    controller: "appColumnChannelOtherViewsCtrl"
                });
                modalInstance.result.then(function(result) {
                    success(result);
                });
            },
            inputPassword: function(success) {
                var modalInstance = $modal.open({
                    templateUrl: "./manageConfig/productManageMent/app/service/inputPassword/inputPassword_tpl.html",
                    windowClass: 'productManageMent-app-channel-delete',
                    backdrop: false,
                    controller: "appInputPasswordCtrl"
                });
                modalInstance.result.then(function(result) {
                    success(result);
                });
            },
            singleChooseChnl: function(modalTitle, siteid, channelid, success) {
                var modalInstance = $modal.open({
                    templateUrl: "./manageConfig/productManageMent/app/service/singleChooseChnl/singleChooseChnl_tpl.html",
                    windowClass: 'app-move-window',
                    backdrop: false,
                    controller: "appManageConfigsingleChooseChnlCtrl",
                    resolve: {
                        draftParams: function() {
                            return {
                                "siteid": siteid,
                                "channelid": channelid,
                                "modalTitle": modalTitle
                            };
                        }
                    }
                });
                modalInstance.result.then(function(result) {
                    success(result);
                });
            },
            /**
             * [getRight description]获取栏目或站点的操作权限
             * @return object [description]
             */
            getRight: function(siteId, channelId, classify) {
                var deffer = $q.defer();
                var params = {
                    serviceid: "mlf_metadataright",
                    methodname: "queryOperKeyById",
                    SiteId: siteId,
                    ChannelId: channelId,
                    Classify: classify
                };
                if (siteId === "") {
                    delete params.SiteId;
                } else {
                    delete params.ChannelId;
                }
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "post")
                    .then(function(data) {
                        deffer.resolve(globleParamsSet.handlePermissionData(data));
                    });
                return deffer.promise;
            },
            /**
             * [getOperType description]获取可以看到或操作的底部标签 如：频道管理，碎片化管理，模板管理，分发配置
             * @return object [description]
             */
            getOperType: function(siteId, channelId) {
                var deffer = $q.defer();
                var params = {
                    serviceid: "mlf_metadataright",
                    methodname: "queryOperTypesByAppBaseChnlId",
                    ChannelId: channelId,
                    SiteId: siteId
                };
                if (siteId === "") {
                    delete params.SiteId;
                } else {
                    delete params.ChannelId;
                }
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "post")
                    .then(function(data) {
                        deffer.resolve(globleParamsSet.handlePermissionData(data));
                    });
                return deffer.promise;
            },
            /**
             * [getOperType description]获取可以看到或操作的底部标签 如：频道管理，碎片化管理，模板管理，分发配置
             * @return object [description]
             */
            getChannelAccessAuthority: function(siteId) {
                var deffer = $q.defer();
                this.getOperType(siteId, "").then(function(data) {
                    var router = "";
                    for (var key in data) {
                        switch (key) {
                            case "channel":
                                router += "channel";
                                break;
                            case "template":
                                router += "template";
                                break;
                                // wf add 4.16
                            case "mark":
                                router += "watermarkmgr";
                                break;
                        }
                        break;
                    }
                    if (router === "") {
                        modalDialog.alertType("", "您无权查看该站点下的频道", "error", true);
                    } else {
                        deffer.resolve({ data: data, router: router });
                    }
                });
                return deffer.promise;
            },
            /**
             * [getOperType description]获取可以看到或操作的底部标签 如：栏目管理，碎片化管理，模板管理
             * @return object [description]
             */
            getCloumnAccessAuthority: function(channelId) {
                var deffer = $q.defer();
                this.getOperType("", channelId).then(function(data) {
                    var router = "";
                    for (var key in data) {
                        switch (key) {
                            case "channel":
                                router += "column";
                                break;
                            case "template":
                                router += "template";
                                break;
                                // wf add 4.16
                            case "mark":
                                router += "watermarkmgr";
                                break;
                        }
                        break;
                    }
                    if (router === "") {
                        modalDialog.alertType("您无权查看该頻道下的栏目", "", "error", true);
                    } else {
                        deffer.resolve({ "data": data, "router": router });
                    }
                });
                return deffer.promise;
            },
            batChooseChnl: function(modalTitle, siteid, success, radio) {
                var modalInstance = $modal.open({
                    templateUrl: "./manageConfig/productManageMent/app/service/batChooseChnl/batChooseChnl_tpl.html",
                    windowClass: 'app-batChooseChnl-window',
                    backdrop: false,
                    controller: "appManageConfigBatChooseChnlCtrl",
                    resolve: {
                        chnlParams: function() {
                            return {
                                "siteid": siteid,
                                "modalTitle": modalTitle,
                                "radio": radio
                                /*"channelid": channelid,
                                "METADATAIDS": METADATAIDS,
                                "methodname": methodname*/
                            };
                        }
                    }
                });
                modalInstance.result.then(function(result) {
                    success(result);
                });
            },
            //新建、(修改)外链配置弹窗
            newAndModifyExternalSys: function(item, siteid, successFn) {
                var modalInstance = $modal.open({
                    templateUrl: "./manageConfig/productManageMent/app/service/newAndModifyExternalSys/newAndModifyExternalSys_tpl.html",
                    windowClass: 'productManageMent-newAndModifyExternalSys-window',
                    backdrop: false,
                    controller: "productManageMentAppNewAndModifyExternalSysCtrl",
                    resolve: {
                        item: function() {
                            return item;
                        },
                        siteid: function() {
                            return siteid;
                        },
                        successFn: function() {
                            return successFn;
                        }
                    }
                });
                return modalInstance.result.then(function(result) {
                    // success(result);
                });
            },
            //新建、(修改)标签弹窗
            newTag: function(item, siteid, successFn) {
                var modalInstance = $modal.open({
                    templateUrl: "./manageConfig/productManageMent/app/service/newTag/newTag_tpl.html",
                    windowClass: 'productManageMent-newTag-window',
                    backdrop: false,
                    controller: "productManageMentAppNewTagCtrl",
                    resolve: {
                        item: function() {
                            return item;
                        },
                        siteid: function() {
                            return siteid;
                        }
                    }
                });
                return modalInstance.result.then(function(result) {
                    successFn(result);
                });
            },
            //分发配置增加(修改)
            /*addClassifyManagement: function(item, successFn) {
                var modalInstance = $modal.open({
                    templateUrl: "./manageConfig/productManageMent/app/distributeConfig/template/addView_tpl.html",
                    windowClass: 'appdistribute-add ',
                    backdrop: false,
                    controller: "appDistributeAddCtrl",
                    resolve: {
                        item: function() {
                            return item;
                        }
                    }
                });
                return modalInstance.result.then(function(result) {

                    successFn(result);
                });
            },*/
            addClassifyManagement: function(item, siteid) {
                var defer = $q.defer();
                var modalInstance = $modal.open({
                    templateUrl: "./manageConfig/productManageMent/app/distributeConfig/template/addView_tpl.html",
                    windowClass: 'appdistribute-add',
                    backdrop: false,
                    controller: "appDistributeAddCtrl",
                    resolve: {
                        item: function() {
                            return item;
                        },
                        siteid: function() {
                            return siteid;
                        }
                    }
                });
                modalInstance.result.then(function(result) {
                    defer.resolve(result);
                }, function() {
                    defer.reject("cancle");
                });
                return defer.promise;
            },

            //app渠道，编辑器字体集合
            fontOptions: function() {
                return [{
                    name: "宋体",
                    value: "宋体"
                }, {
                    name: "微软雅黑",
                    value: "微软雅黑"
                }, {
                    name: "楷体",
                    value: "楷体"
                }, {
                    name: "黑体",
                    value: "黑体"
                }, {
                    name: "隶书",
                    value: "隶书"
                }, {
                    name: "andale mono",
                    value: "andale mono"
                }, {
                    name: "arial",
                    value: "arial"
                }, {
                    name: "arial black",
                    value: "arial black"
                }, {
                    name: "comic sans ms",
                    value: "comic sans ms"
                }, {
                    name: "impact",
                    value: "impact"
                }, {
                    name: "times new roman",
                    value: "times new roman"
                }];
            },
            //app渠道，编辑器行间距
            lineSpacings: function() {
                return [{
                    name: "1",
                    value: "1"
                }, {
                    name: "1.5",
                    value: "1.5"
                }, {
                    name: "1.75",
                    value: "1.75"
                }, {
                    name: "2",
                    value: "2"
                }, {
                    name: "3",
                    value: "3"
                }, {
                    name: "4",
                    value: "4"
                }, {
                    name: "5",
                    value: "5"
                }];
            },
            //app渠道，编辑器字体大小
            fontSize: function() {
                return [{
                    name: "10px",
                    value: "10px"
                }, {
                    name: "11px",
                    value: "11px"
                }, {
                    name: "12px",
                    value: "12px"
                }, {
                    name: "14px",
                    value: "14px"
                }, {
                    name: "16px",
                    value: "16px"
                }, {
                    name: "18px",
                    value: "18px"
                }, {
                    name: "20px",
                    value: "20px"
                }, {
                    name: "24px",
                    value: "24px"
                }, {
                    name: "36px",
                    value: "36px"
                }];
            },
            /**
             * [thirdPartyConfig description] 新增或修改组件接口配置
             * @param  {[type]} item [description] 修改项信息
             * @param  {[type]} siteId [description] 站点id
             * @return {[type]}      [description]
             */
            thirdPartyConfig(item,siteId) {
                let defer = $q.defer();
                let modalInstance = $modal.open({
                    templateUrl: "./manageConfig/productManageMent/app/service/thirdPartyConfig/createThirdPartyConfig_tpl.html",
                    windowClass: 'createThirdPartyConfig',
                    backdrop: false,
                    controller: "createThirdPartyConfigCtrl",
                    resolve: {
                        item(){
                            return item
                        },
                        siteId(){
                            return siteId
                        }
                    }
                });
                modalInstance.result.then(function(result) {
                    defer.resolve(result);
                }, function() {
                    defer.reject("cancle");
                });
                return defer.promise;
            }
        };
    }]);